module.exports = __webpack_public_path__ + "static/media/18c-04_barro.2ba4e8ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18c/18c-04_barro.jpg
// module id = 231
// module chunks = 0